import React from 'react';
import { generateClassName } from './helpers';

import './FieldIcon.css';

const FieldIcon = ({ label = null, icon = null, className = null }) => {
    return (
        <div className={generateClassName('field-icon', '', className)}>
            {label && (
                <div className={generateClassName('field-icon', '-label', className)}>
                    {label}
                </div>
            )}
            {icon && (
                <div className={generateClassName('field-icon', '-icon', className)}>
                    {icon}
                </div>
            )}
        </div>
    );
};

export default FieldIcon;